export * from './src/multilingual-settings-v2-locale-settings-locale-settings.context.js';
